<form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
  <app-scroll-view class="scroll-view">
    <section class="section-form">
      <div class="field-set">
        <label label>ASSUNTO*</label>

        <app-input-box
          formControlName="subject"
          [showErrorEnabled]="false"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-input-box>
      </div>

      <div class="field-set">
        <label label>DESCRIÇÃO</label>

        <app-text-area
          formControlName="description"
          [rows]="3"
          resize="none"
          [showErrorEnabled]="false"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-text-area>
      </div>
    </section>

    <section class="section-form section-list">
      <input
        #attachmentFileInputEl
        type="file"
        multiple="false"
        [hidden]="true"
        (change)="onAttachmentFileChange()"
      />

      <ng-template
        [ngTemplateOutlet]="sectionListTpl"
        [ngTemplateOutletContext]="attachmentsSectionListContext"
      ></ng-template>
    </section>

    <section class="section-form section-list section-select-objects">
      <div class="section-list-content">
        <app-toolbar class="section-toolbar">
          <div appToolbarItemBefore class="title">SELECIONAR OBJETOS</div>

          <div
            *ngIf="!isEditMode"
            appToolbarItemAfter
            class="btn-item btn-select-objects-container"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <app-button
              buttonType="primary"
              styleType="contained"
              sizeType="small"
              text="Selecionar área"
              (click)="onBtnSelectGeometryInMapClick()"
            >
            </app-button>
          </div>
        </app-toolbar>

        <app-select-objects-table
          [fields]="areaGridFields"
          [resultList]="areaResultListToSelect"
          [(selectedItemKeys)]="areaResultListKeysSelected"
          [keyExpr]="areaResultKeyExpr"
          [showSelectControlsEnabled]="!isEditMode"
        ></app-select-objects-table>
      </div>
    </section>
  </app-scroll-view>

  <div class="actions-bottom">
    <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
      <app-button
        type="submit"
        buttonType="primary"
        styleType="contained"
        text="Gravar"
      ></app-button>
    </div>

    <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
      <app-button
        buttonType="normal"
        styleType="contained"
        text="Cancelar"
        (click)="onBtnClearClick()"
      ></app-button>
    </div>
  </div>
</form>

<ng-template
  #sectionListTpl
  let-title="title"
  let-onAddClick="onAddClick"
  let-onDeleteClick="onDeleteClick"
  let-pageObj="pageObj"
  let-columnsCount="columnsCount"
>
  <div class="section-list-content">
    <app-toolbar class="section-toolbar">
      <div appToolbarItemBefore class="title">
        {{ title }}
      </div>

      <div
        appToolbarItemAfter
        class="btn-item"
        #btnAddItem
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
        <app-button
          buttonType="normal"
          styleType="text"
          sizeType="large"
          shapeType="circle"
          icon="assets/icons/circle-plus.svg"
          (click)="onAddClick?.($event)"
        >
        </app-button>

        <app-tooltip
          [target]="btnAddItem"
          verticalAlignment="center"
          horizontalAlignment="left"
        >
          Adicionar
        </app-tooltip>
      </div>
    </app-toolbar>

    <app-list
      class="list"
      [items]="pageObj.items"
      [scrollable]="false"
      keyExpr="data"
    >
      <ng-template listContainer let-itemListTemplate="itemListTemplate">
        <div class="row">
          <ng-template [ngTemplateOutlet]="itemListTemplate"></ng-template>
        </div>
      </ng-template>

      <ng-template listItem let-item="item" let-index="index">
        <div class="col-md-{{ 12 / (columnsCount ?? 1) }}">
          <div class="item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
            <div class="btn-delete-item" #btnDeleteItem>
              <app-button
                buttonType="danger"
                styleType="text"
                shapeType="circle"
                icon="assets/icons/trash.svg"
                (click)="onDeleteClick?.(item, index)"
              ></app-button>

              <app-tooltip
                [target]="btnDeleteItem"
                verticalAlignment="top"
                horizontalAlignment="center"
              >
                Deletar
              </app-tooltip>
            </div>

            <div class="text">
              {{ item?.text }}
            </div>
          </div>
        </div>
      </ng-template>
    </app-list>

    <div class="pagination-container">
      <app-pagination
        [totalCount]="pageObj.totalCount"
        [pageSize]="pageObj.pageSize"
        [pageIndex]="pageObj.pageIndex"
        (pageIndexChange)="pageObj.onPageChange?.($event)"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-pagination>
    </div>
  </div>
</ng-template>
